import { gql } from "@apollo/client";

export const GET_PERMISSIONS = gql`
  query GetPermissions($query: QueryInput, $permission: PermissionInput) {
    permissions(query: $query, permission: $permission) {
      permissions {
        _id
        name
        description
        notes
        tags
      }
      metaData {
        totalCount
        totalPages
      }
    }
  }
`;
